import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Loadings from '../../../constants/loadings/backoffice/configuration';
import { toast } from 'react-toastify';
import * as R from "ramda";
import $ from 'jquery';

import { ConfigurationClientTable } from './table';
import { createPostalNumber, getProductsPrices, updateProductPrice } from '../../../actions/backoffice/configuration';

export const ConfigurationGeneral = ({ configState, pageNumber }) => {

	const dispatch = useDispatch();
	const impressionFormRef = useRef(null);
	const pricesFormRef = useRef(null);
	const buttonImpressionRef = useRef(null);
	const buttonPriceRef = useRef(null);
	const [isLoading, setIsLoading] = useState(false);
	const toastConf = { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 };

	const [impression, setImpression] = useState({ start: "", end: "" });
	// const [facilita, setFacilia] = useState({ facilita: !R.isNil(configState.prices) ? configState.prices.facilita : { product: "", id: "", basePrice: "" } });
	// const [partner, setParnter] = useState({ partner: !R.isNil(configState.prices) ? configState.prices.trainingday : { product: "", id: "", basePrice: "" } });
	// const [anticipa, setAnticipa] = useState({ anticipa: !R.isNil(configState.prices) ? configState.prices.setupfee1 : { product: "", id: "", basePrice: "" } });
	// const [anticipa1, setAnticipa1] = useState({ anticipa4: !R.isNil(configState.prices) ? configState.prices.setupfee4 : { product: "", id: "", basePrice: "" } });
	// const [anticipa4, setAnticipa4] = useState({ anticipa6: !R.isNil(configState.prices) ? configState.prices.setupfee6 : { product: "", id: "", basePrice: "" } });
	// const [anticipa6, setAnticipa6] = useState({ annual: !R.isNil(configState.prices) ? configState.prices.annual : { product: "", id: "", basePrice: "" } });

	const empty = { product: "", id: "", basePrice: "" };
	const [formPrice, setFormPrice] = useState({
		facilita: configState.prices?.facilita ?? empty,
		facilita4: configState.prices?.facilita4 ?? empty,
		partner: configState.prices?.trainingday ?? empty,
		anticipa: configState.prices?.setupfee1 ?? empty,
		anticipaMinus65: configState.prices?.anticipaMinus65 ?? empty,
		anticipa4: configState.prices?.setupfee4 ?? empty,
		anticipa6: configState.prices?.setupfee6 ?? empty,
		anticipaMonthly: configState.prices?.anticipaMonthly ?? empty,
		annual: configState.prices?.annual ?? empty,

	});

	useEffect(() => {

		const empty = { product: "", id: "", basePrice: "" };
		setFormPrice({
			facilita: configState.prices?.facilita ?? empty,
			facilita4: configState.prices?.facilita4 ?? empty,
			partner: configState.prices?.trainingday ?? empty,
			anticipa: configState.prices?.setupfee1 ?? empty,
			anticipaMinus65: configState.prices?.setupfee1minus65 ?? empty,
			anticipa4: configState.prices?.setupfee4 ?? empty,
			anticipa6: configState.prices?.setupfee6 ?? empty,
			anticipaMonthly: configState.prices?.setupmonthly ?? empty,
			annual: configState.prices?.annual ?? empty,
		});

	}, [configState.prices]);




	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	function handleSubmitImpressionForm(e) {

		e.preventDefault();
		if (R.isEmpty(impression.start) && R.isEmpty(impression.end)) {
			return;
		}

		impressionFormRef.current.classList.add("was-validated");

		if (impressionFormRef.current.checkValidity()) {
			const start = parseInt(impression.start);
			const end = parseInt(impression.end);


			dispatch(createPostalNumber({ start, end }));
		}

	}

	function handleSubmitPriceForm(e) {
		e.preventDefault();
		const facilitaPrice = parseFloat(formPrice.facilita.basePrice);
		const anticipaPrice = parseFloat(formPrice.anticipa.basePrice);
		const anticipa4Price = parseFloat(formPrice.anticipa4.basePrice);
		const anticipa6Price = parseFloat(formPrice.anticipa6.basePrice);
		const partnerPrice = parseFloat(formPrice.partner.basePrice);
		const annualPrice = parseFloat(formPrice.annual.basePrice);


		if (facilitaPrice === configState.prices.facilita.basePrice &&
			anticipaPrice === configState.prices.setupfee1.basePrice &&
			anticipa4Price === configState.prices.setupfee4.basePrice &&
			anticipa6Price === configState.prices.setupfee6.basePrice &&
			partnerPrice === configState.prices.trainingday.basePrice &&
			annualPrice === configState.prices.annual.basePrice
		) {
			return;
		}

		pricesFormRef.current.classList.add("was-validated");

		if (pricesFormRef.current.checkValidity()) {
			setIsLoading(true);
			let productsNewPrices = [];
			let oldProducts = formPrice;

			if (facilitaPrice !== configState.prices.facilita.basePrice) {
				productsNewPrices.push({ ...formPrice.facilita, basePrice: facilitaPrice });
			}
			if (anticipaPrice !== configState.prices.setupfee1.basePrice) {
				productsNewPrices.push({ ...formPrice.anticipa, basePrice: anticipaPrice });
			}
			if (anticipa4Price !== configState.prices.setupfee4.basePrice) {
				productsNewPrices.push({ ...formPrice.anticipa4, basePrice: anticipa4Price });
			}
			if (anticipa6Price !== configState.prices.setupfee6.basePrice) {
				productsNewPrices.push({ ...formPrice.anticipa6, basePrice: anticipa6Price });
			}
			if (partnerPrice !== configState.prices.trainingday.basePrice) {
				productsNewPrices.push({ ...formPrice.partner, basePrice: partnerPrice });
			}
			if (annualPrice !== configState.prices.annual.basePrice) {
				productsNewPrices.push({ ...formPrice.annual, basePrice: annualPrice });
			}


			let productPromises = [];
			productsNewPrices.forEach(product => {
				productPromises.push(updateProductPrice(product));
			});

			Promise.all(productPromises).then(response => {
				setIsLoading(false);
				toast.success("submitted", toastConf);
			}).catch(error => {
				setIsLoading(false);
				toast.error(error.message, toastConf);
			});

			//dispatch(updateProductPrice(product))
		}


	}

	// if (paymentState.isLoading.includes(Loadings.FETCHING_CLIENTS_INVOICES)) { return <LoadingState />; }
	// if (R.isNil(paymentState.clientsInvoices)) { return ''; }

	return (
		<React.Fragment>
			<div className="auto-view h-100 mb-auto">
				<div className="container-fluid">
					<article className="block my-sm mb-lg-lg">
						<header className="block mb-4">
							<h5 className="sr-only visually-hidden">Impression préférences</h5>
							<div className="flex-row grid-sm grid-sm-1 grid-md-3 align-items-center">
								<div className="h3 font-weight-bold my-auto grid-column-md-2">Impressions préférences</div>
							</div>
						</header>
						<section className="block">
							<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-0">Plage de numéros de recommandés</h4>
							<form className="pt-sm" noValidate id="general" ref={impressionFormRef} onSubmit={handleSubmitImpressionForm}>
								<div className="row container-default align-items-center gx-1">
									<div className="col">
										<div className="form-group row align-items-center gx-1">
											<div className="col-auto col-xl-1">
												<label className="h6 font-weight-bolder" htmlFor="de">De</label>
											</div>
											<div className="col">
												{/* <input type="number" className="form-control" id="de" placeholder="00000" required pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" value={impression.start} onChange={(e) => setImpression({ ...impression, start: e.target.value })} /> */}
												<input type="number" className="form-control" id="de" placeholder="00000" required max={"9999999999"} min="0" value={impression.start} onChange={(e) => setImpression({ ...impression, start: e.target.value })} />
											</div>
											<div className={"invalid-feedback"}>
												Champs invalide
											</div>
										</div>
									</div>
									<div className="col">
										<div className="form-group row align-items-center gx-1">
											<div className="col-auto col-xl-1 text-center">
												<label className="h6 font-weight-bolder" htmlFor="a">à</label>
											</div>
											<div className="col">
												<input type="number" className="form-control" id="a" placeholder="20000" required max={"9999999999"} min={String(parseInt(impression.start) + 1)} value={impression.end} onChange={(e) => setImpression({ ...impression, end: e.target.value })} />
											</div>
											<div className={"invalid-feedback"}>
												Champs invalide
											</div>
										</div>
									</div>
								</div>
								<button type="submit" className='sr-only visually-hidden' ref={buttonImpressionRef}>Sent</button>
							</form>
						</section>
					</article>
					<article className="block my-sm mb-lg-lg">
						<header className="block">
							<h5 className="sr-only visually-hidden">Tarifs préférences</h5>
							<div className="flex-row grid-sm grid-sm-1 grid-md-3 align-items-center">
								<div className="h3 font-weight-bold my-auto grid-column-md-2">Tarifs préférences</div>
							</div>
						</header>
						<form className="block container-hd" noValidate id="general" ref={pricesFormRef} onSubmit={handleSubmitPriceForm}>
							<div className="row gx-3">
								<div className="col-4">
									<section className="block mt-sm">
										<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2">Facilita</h4>
										<label className="h6 font-weight-bolder" htmlFor="ouvertureFacilita">L'ouverture de compte</label>
										<div className="row align-items-center gx-1">
											<div className="col">
												<div className="form-group align-items-center gx-1">
													<div className="col-12">
														<label className="fs-3 o-60 ls-1 font-weight-bolder text-uppercase" htmlFor="1x">Paiement en 1x</label>
													</div>
													<div className='col'>
														<div className="input-group">
															<span className="input-group-prepend">
																<i className="input-group-text fs-inherit lh-0 border-right-0">€</i>
															</span>
															<input type="number" className="form-control" id="ouvertureFacilita" placeholder="00000" required min="0" step="0.01" value={formPrice.facilita.basePrice} onChange={(e) => setFormPrice({ ...formPrice, facilita: { ...formPrice.facilita, basePrice: e.target.value } })} />
														</div>
													</div>
													<div className="invalid-feedback"> Champs invalide </div>
												</div>
											</div>
											<div className="col">
												<div className="form-group align-items-center gx-1">
													<div className="col-12">
														<label className="fs-3 o-60 ls-1 font-weight-bolder text-uppercase" htmlFor="1x">Paiement en 4x</label>
													</div>
													<div className='col'>
														<div className="input-group">
															<span className="input-group-prepend">
																<i className="input-group-text fs-inherit lh-0 border-right-0">€</i>
															</span>
															<input type="number" className="form-control" id="ouvertureFacilita" placeholder="00000" required min="0" step="0.01" value={formPrice.facilita4.basePrice} onChange={(e) => setFormPrice({ ...formPrice, facilita4: { ...formPrice.facilita4, basePrice: e.target.value } })} />
														</div>
													</div>
													<div className="invalid-feedback"> Champs invalide </div>
												</div>
											</div>
										</div>
									</section>
									<section className="block mt-sm">
										<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2">Partenaire</h4>
										<div className="row align-items-center gx-1">
											<div className="col">
												<div className="form-group align-items-center">
													<label className="h6 font-weight-bolder" htmlFor="ouvertureFacilita">Formation partenaire</label>
													<div className="input-group">
														<span className="input-group-prepend">
															<i className="input-group-text fs-inherit lh-0 border-right-0">€</i>
														</span>
														<input type="number" className="form-control" id="ouvertureFacilita" placeholder="00000" required min="0" step="0.01" disabled value={formPrice.partner.basePrice} onChange={(e) => setFormPrice({ ...formPrice, partner: { ...formPrice.partner, basePrice: e.target.value } })} />
													</div>
												</div>
												<div className="invalid-feedback"> Champs invalide </div>
											</div>
										</div>
									</section>
								</div>
								<div className="col-md">
									<section className="block mt-sm">
										<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2">Anticipa</h4>
										<div className="form-group align-items-center">
											<label className="h6 font-weight-bolder" htmlFor="ouvertureFacilita">L'ouverture de compte</label>
											<div className="row align-items-center gx-1">
												<div className="col">
													<div className="form-group row align-items-center gx-1">
														<div className="col-12">
															<label className="fs-3 o-60 ls-1 font-weight-bolder text-uppercase" htmlFor="1x">Paiement en 1x (&ge;65)</label>
														</div>
														<div className="col">
															<div className="input-group">
																<span className="input-group-prepend">
																	<i className="input-group-text fs-inherit lh-0 border-right-0">€</i>
																</span>
																<input type="number" className="form-control" id="1x" placeholder="00000" required min="0" step="0.01" value={formPrice.anticipa.basePrice} onChange={(e) => setFormPrice({ ...formPrice, anticipa: { ...formPrice.anticipa, basePrice: e.target.value } })} />
															</div>
														</div>
														<div className={"invalid-feedback"}>
															Champs invalide
														</div>
													</div>
												</div>
												<div className="col">
													<div className="form-group row align-items-center gx-1">
														<div className="col-12">
															<label className="fs-3 o-60 ls-1 font-weight-bolder text-uppercase" htmlFor="1xMinus65">Paiement en 1x (&lt;65)</label>
														</div>
														<div className="col">
															<div className="input-group">
																<span className="input-group-prepend">
																	<i className="input-group-text fs-inherit lh-0 border-right-0">€</i>
																</span>
																<input type="number" className="form-control" id="1xMinus65" placeholder="00000" required min="0" step="0.01" value={formPrice.anticipaMinus65.basePrice} onChange={(e) => setFormPrice({ ...formPrice, anticipaMinus65: { ...formPrice.anticipaMinus65, basePrice: e.target.value } })} />
															</div>
														</div>
														<div className={"invalid-feedback"}>
															Champs invalide
														</div>
													</div>
												</div>
												<div className="col">
													<div className="form-group row align-items-center gx-1">
														<div className="col-12">
															<label className="fs-3 o-60 ls-1 font-weight-bolder text-uppercase" htmlFor="4x">Paiement en 4x (&ge;65)</label>
														</div>
														<div className="col">
															<div className="input-group">
																<span className="input-group-prepend">
																	<i className="input-group-text fs-inherit lh-0 border-right-0">€</i>
																</span>
																<input type="number" className="form-control" id="4x" placeholder="20000" required min="0" step="0.01" value={formPrice.anticipa4.basePrice} onChange={(e) => setFormPrice({ ...formPrice, anticipa4: { ...formPrice.anticipa4, basePrice: e.target.value } })} />
															</div>
														</div>
														<div className={"invalid-feedback"}>
															Champs invalide
														</div>
													</div>
												</div>
												<div className="col">
													<div className="form-group row align-items-center gx-1">
														<div className="col-12">
															<label className="fs-3 o-60 ls-1 font-weight-bolder text-uppercase" htmlFor="6x">Paiement en 6x (&ge;65)</label>
														</div>
														<div className="col">
															<div className="input-group">
																<span className="input-group-prepend">
																	<i className="input-group-text fs-inherit lh-0 border-right-0">€</i>
																</span>
																<input type="number" className="form-control" id="6x" placeholder="20000" required min="0" step="0.01" value={formPrice.anticipa6.basePrice} onChange={(e) => setFormPrice({ ...formPrice, anticipa6: { ...formPrice.anticipa6, basePrice: e.target.value } })} />
															</div>
														</div>
														<div className={"invalid-feedback"}>
															Champs invalide
														</div>
													</div>
												</div>
												<div className="col">
													<div className="form-group row align-items-center gx-1">
														<div className="col-12">
															<label className="fs-3 o-60 ls-1 font-weight-bolder text-uppercase" htmlFor="monthly">Paiement mensuel (&lt;65)</label>
														</div>
														<div className="col">
															<div className="input-group">
																<span className="input-group-prepend">
																	<i className="input-group-text fs-inherit lh-0 border-right-0">€</i>
																</span>
																<input type="number" className="form-control" id="monthly" placeholder="20000" required min="0" step="0.01" value={formPrice.anticipaMonthly.basePrice} onChange={(e) => setFormPrice({ ...formPrice, anticipaMonthly: { ...formPrice.anticipaMonthly, basePrice: e.target.value } })} />
															</div>
														</div>
														<div className={"invalid-feedback"}>
															Champs invalide
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="row align-items-center gx-1">
											<div className="col">
												<div className="form-group align-items-center">
													<label className="h6 font-weight-bolder" htmlFor="ouvertureFacilita">Renouvellement</label>
													<div className="input-group">
														<span className="input-group-prepend">
															<i className="input-group-text fs-inherit lh-0 border-right-0">€</i>
														</span>
														<input type="number" className="form-control" id="ouvertureFacilita" placeholder="00000" required min="0" step="0.01" value={formPrice.annual.basePrice} onChange={(e) => setFormPrice({ ...formPrice, annual: { ...formPrice.annual, basePrice: e.target.value } })} />
													</div>
													<div className={"invalid-feedback"}>
														Champs invalide
													</div>
												</div>
											</div>
										</div>
									</section>
								</div>
							</div>
							<button type="submit" className='sr-only visually-hidden' ref={buttonPriceRef}>Sent</button>
						</form>
					</article>
				</div>
			</div>
			<div className="container-fluid">
				<footer className="flex-md-row align-items-center mt-auto mb-sm w-100">
					{isLoading ?
						<button className="btn btn-info loading-btn show no-event o-90">
							Sauvegarder
							<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
						</button>
						:
						<button className="btn btn-info" disabled={configState.isLoading.includes(Loadings.FETCHING_PRICES)} onClick={() => {
							buttonImpressionRef.current.click();
							buttonPriceRef.current.click();
						}}>Sauvegarder</button>
					}
					<h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
				</footer>
			</div>
		</React.Fragment>
	);
};